// extracted by mini-css-extract-plugin
export default {"card":"nRRjV8","card--full-height":"lvnVnT","card--full-width":"hnag9X"};